import { defineStore } from 'pinia';
import { ref } from 'vue';
import { BASE_STORAGE_KEY } from '@/utils/constants';
import { getOrganization } from '@/services/organizationLambda';
import { getDashboardConversations } from '@/services/ConversationsApiService';
import { getAnnualReports } from '@/services/reportsLambda';
import { useAuthStore } from './authStore';
import SecureLS from 'secure-ls';

const ls = new SecureLS({ encodingType: 'aes', storage: sessionStorage  });

const LOCAL_STORAGE_KEY = `${BASE_STORAGE_KEY}:dashboard`;
export const useDashboardStore = defineStore(LOCAL_STORAGE_KEY, () => {

  const authStore = useAuthStore();

  // State
  const organization = ref(null);
  const conversations = ref([]);
  const pendingReports = ref([]);
  const lastFetched = ref(null);

  // Actions
  async function fetch() {
    const [orgData, convData, reportData] = await Promise.all([
      getOrganization(authStore.user.primaryOrganizationId),
      getDashboardConversations(authStore.user.primaryOrganizationId),
      getAnnualReports(false),
    ]);

    organization.value = orgData;
    conversations.value = convData;
    pendingReports.value = reportData;
  }

  async function refreshOrganization() {
    organization.value = await getOrganization(authStore.user.primaryOrganizationId);
  }

  return {
    organization,
    conversations,
    pendingReports,
    lastFetched,

    fetch,
    refreshOrganization,
  };
},
{
  persist: {
    storage: {
      getItem: key => {
        const data = ls.get(key);
        return typeof data === 'string' ? data : JSON.stringify(data);
      },
      setItem: (key, value) => {
        ls.set(key, value);
      },
      removeItem: key => {
        ls.remove(key);
      }
    }
  }
});